import React from 'react';
import { connect } from 'react-redux';
import { MDTApp } from '../../../../../actions/bootAction.js';
import { sendEventTrackingData } from '../../../../../helpers/commonUtils.js';
import { NotificationIcon } from '../../../../atoms/mdt-iconset/index.js';
import './userCartCount.css';

const userCartCount = (props) => {
    const onCartClick = () => {
        const eventParamObj = {
            eventCategory: 'globalHeader',
            eventAction: 'cart',
            eventLabel: props.pageName,
            processLabels: false,
        };
        sendEventTrackingData(eventParamObj);
        props.cartLink();
    };

    return (
        <NotificationIcon
            onIconClicked={onCartClick}
            className='user-cart-count'
            iconWhenNotification='cartFilled'
            iconEmpty='unfilledCart'
            iconCount={props.cartCount}
        />
    );
};

const mapStateToProps = (state) => {
    return {
        cartCount: state.wishList.productCount,
        pageName: state.page,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        cartCountInvoke: () => dispatch(MDTApp.fetchWishlist()),
        cartLink: () => dispatch({ type: 'CART' }),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(userCartCount);
